import React from "react";
import CustomImage from "../../CustomImage";
import styles from "./IntroAd.module.scss";
import { isFrappeOrJotFormClass } from "../../../utils/helpers";

export interface IntroAdData {
  id?: number;
  link?: string;
  formId?: string | null;
  desktopImg?: { url?: string; width?: number; height?: number; alternativeText?: string | null } | null;
}

interface Props {
  introAd: IntroAdData;
}

const IntroAd: React.FC<Props> = ({ introAd }) => {
  if (!introAd?.desktopImg?.url) return null;

  const formClass = introAd?.link ? "" : isFrappeOrJotFormClass(introAd?.formId ?? "");

  const image = (
    <CustomImage
      src={introAd.desktopImg.url}
      height={264}
      width={975}
      alt="advertisement"
      isLazyLoad={true}
      priority={false}
    />
  );

  return (
    <div className={`${styles.introAd} ${formClass}`}>
      {introAd?.link ? (
        <a href={introAd.link} target="_blank" rel="noopener noreferrer" aria-label="advertisement">
          {image}
        </a>
      ) : (
        image
      )}
    </div>
  );
};

export default IntroAd;
